import { render, staticRenderFns } from "./FalecidoLegado.vue?vue&type=template&id=3b1c0b9b&"
import script from "./FalecidoLegado.vue?vue&type=script&lang=js&"
export * from "./FalecidoLegado.vue?vue&type=script&lang=js&"
import style0 from "./FalecidoLegado.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports